import { render, staticRenderFns } from "./ProjectAuditLogs.vue?vue&type=template&id=1e341bef&scoped=true&"
import script from "./ProjectAuditLogs.vue?vue&type=script&lang=js&"
export * from "./ProjectAuditLogs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e341bef",
  null
  
)

export default component.exports